module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-manager"
  }, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "227",
      "height": "227"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "425",
      "height": "425"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "850",
      "height": "850"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-manager-search column-content"
  }, [_c('span', {
    staticClass: "sub-id-txt span-14"
  }, [_vm._v("子站编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入子站编号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteListSearch()
      }
    },
    model: {
      value: (_vm.subSiteId),
      callback: function($$v) {
        _vm.subSiteId = $$v
      },
      expression: "subSiteId"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-name-txt span-14"
  }, [_vm._v("子站名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入子站名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteListSearch()
      }
    },
    model: {
      value: (_vm.subSiteName),
      callback: function($$v) {
        _vm.subSiteName = $$v
      },
      expression: "subSiteName"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        _vm.subsiteListSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-list"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("子站列表")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "subSiteId",
      "label": "子站编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subSiteName",
      "label": "子站名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "链接",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "sub-url",
          attrs: {
            "href": scope.row.subsiteRealUrl
          }
        }, [_vm._v("此链接为" + _vm._s(scope.row.promotor.name) + "的销售链接")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "子站二维码",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "left"
          }
        }, [_c('div', {
          staticClass: "preQr"
        }, [_c('p', [_vm._v(_vm._s(((scope.row.subSiteName) + "（子站二维码）")))]), _vm._v(" "), _c('img', {
          attrs: {
            "src": scope.row.subsiteRealQrcode
          }
        }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper column-content qr-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('img', {
          staticClass: "qrImg",
          attrs: {
            "src": scope.row.subsiteRealQrcode
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "注册二维码",
      "width": "120",
      "label-class-name": "codeTip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "left"
          }
        }, [_c('div', {
          staticClass: "preQr"
        }, [_c('p', [_vm._v(_vm._s(((scope.row.subSiteName) + "（注册二维码）")))]), _vm._v(" "), _c('img', {
          attrs: {
            "src": scope.row.subsiteSigninQrCode
          }
        }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper column-content qr-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('img', {
          staticClass: "qrImg",
          attrs: {
            "src": scope.row.subsiteSigninQrCode
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "width": "169"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.getFormatTime(scope.row.createAt)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handle",
      "label": "操作",
      "width": "185"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operate-button"
        }, [(_vm.promotorType === 1 && _vm.accountState === 1) ? _c('p', {
          staticClass: "modifySub"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'substationSet',
              query: {
                sid: scope.row.subSiteId
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("修改设置")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeName(scope.row.subSiteId, scope.$index)
            }
          }
        }, [_vm._v("修改名称")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('el-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: (("" + (scope.row.subsiteRealUrl))),
            expression: "`${scope.row.subsiteRealUrl}`",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: (_vm.onCopy),
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: (_vm.onError),
            expression: "onError",
            arg: "error"
          }],
          staticClass: "copy-url",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("复制链接")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.downloadQr(scope.row.subsiteRealQrcode, scope.row.subSiteName)
            }
          }
        }, [_vm._v("保存子站二维码")])], 1), _vm._v(" "), _c('p', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.downloadQr(scope.row.subsiteSigninQrCode, scope.row.subSiteName + '(注册)')
            }
          }
        }, [_vm._v("保存注册二维码")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.listData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.listData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.listData, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "oTip"
  }, [_vm._v("用户扫描本二维码后，会直接进入登录页面。用户通过本链接成为新注册用户，该用户将会被您锁定。")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b035938","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/subStation/subManager.vue
// module id = 941
// module chunks = 1